import { Injectable } from '@angular/core';

import { DeleteCommandService } from 'pbc.angular';

import { IDeleteZeitArtRequest, IDeleteZeitArtResponse } from 'fa-kt.types';

@Injectable({
  providedIn: 'root',
})
export class DeleteZeitArtCommandService extends DeleteCommandService<IDeleteZeitArtRequest, IDeleteZeitArtResponse> {
  readonly route = 'zeiten/settings/zeit-art';
}
